<template>
  <select class="form-control m-input" @select="emitChangeEvent" @change="emitChangeEvent">
    <option value="">{{ firstOption }}</option>
    <option
      v-for="role in selects"
      :key="role.id"
      :value="role.id"
      :selected="role.id == selected"
      >{{ role.name }}</option
    >
  </select>
</template>

<script>
import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  name: 'SelectRoles',
  data() {
    return {
      selectedRoleId: '',
      firstOption: this.first ? this.first : 'Todos',
      selects: [],
    };
  },
  props: {
    selected: {
      type: [Number, String],
    },
    first: {
      type: String,
    },
  },
  methods: {
    getData() {
      axios(`${baseApiUrl}/v1/role/all`).then((res) => (this.selects = res.data));
    },
    emitChangeEvent(variable) {
      this.$emit('change', variable.target.value);
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
